export default {
    data () {
        return {
            possibleFilters: [
                { name: 'taken', label: 'Verhuurd' },
                { name: 'taken+reserved', label: 'Verhuurd + Gereserveerd' },
                { name: 'inactive', label: 'Inactief' },
                { name: 'free', label: 'Vrij' },
                { name: 'reserved', label: 'Gereserveerd' },
                { name: 'ending', label: 'Aflopend' },
                // { name: 'escalated', label: 'Geëscaleerd' },
                // { name: 'escalated_deurwaarder', label: 'Deurwaarder' },
            ],
        }
    },

    computed: {
        selectedFilters: {
            get() {
                return this.$store.state.selectedFilters || this.possibleFilters.map(f => f.name)
            },
            set(value) {
                this.$store.dispatch('setSelectedFilters', value)
            }
        }
    },

    created() {
        if (this.showEscalation) {
            this.addEscalationFilters()
        }

        // Initialize store with default filters if not set
        if (!this.$store.state.selectedFilters) {
            this.selectedFilters = this.possibleFilters.map(f => f.name)
        }
    },

    methods: {
        addEscalationFilters() {
            // First add the filters to possibleFilters if they don't exist
            if (!this.possibleFilters.find(f => f.name === 'escalated')) {
                this.possibleFilters.push({ name: 'escalated', label: 'Geëscaleerd' })
            }
            if (!this.possibleFilters.find(f => f.name === 'escalated_deurwaarder')) {
                this.possibleFilters.push({ name: 'escalated_deurwaarder', label: 'Deurwaarder' })
            }

            // Only add to selectedFilters if all other filters are currently selected
            const currentFilters = [...this.selectedFilters]
            const nonEscalationFilters = this.possibleFilters
                .filter(f => f.name !== 'escalated' && f.name !== 'escalated_deurwaarder')
                .map(f => f.name)

            const allNonEscalationSelected = nonEscalationFilters.every(f => currentFilters.includes(f))

            if (allNonEscalationSelected) {
                if (!currentFilters.includes('escalated')) {
                    currentFilters.push('escalated')
                }
                if (!currentFilters.includes('escalated_deurwaarder')) {
                    currentFilters.push('escalated_deurwaarder')
                }
                this.selectedFilters = currentFilters
            }
        },

        handleFilterClick(filterName) {
            if (filterName === 'all') {
                this.selectedFilters = this.possibleFilters.map(f => f.name)
                return
            }

            if (filterName === 'none') {
                this.selectedFilters = ['none']
                return
            } else {
                // Always remove none
                this.selectedFilters = this.selectedFilters.filter(f => f !== 'none')
            }

            // Check if all filters are selected, when selecting one, select only that one.
            if ([...this.selectedFilters].length === this.possibleFilters.length) {
                this.selectedFilters = [filterName]
                return
            }

            const index = this.selectedFilters.indexOf(filterName)

            if (index === -1) {
                this.selectedFilters.push(filterName)
            } else {
                this.selectedFilters.splice(index, 1)
            }

            // If no filters are selected after the operation, select all
            if (this.selectedFilters.length === 0) {
                this.selectedFilters = this.possibleFilters.map(f => f.name)
            }
        }
    },
}